import { Text } from '@wix/design-system';
import { ArrowDownSmall, ArrowUpSmall, ChevronCollapseSmall } from '@wix/wix-ui-icons-common';
import { round } from '../utils/logic';

interface Props {
    before: number;
    after: number;
}

function Trend(props: Props) {
    const { before, after } = props

    const diff = round(after - before)

    const renderIcon = () => {
        if (diff > 0) {
            return <ArrowUpSmall />
        }
        if (diff < 0) {
            return <ArrowDownSmall />
        }

        return <ChevronCollapseSmall />
    }

    let colorClassName = '';
    if (diff > 0) {
        colorClassName += ' text-success';
    }
    if (diff < 0) {
        colorClassName += ' text-danger';
    }


    return <div className={`center ${colorClassName}`}>

        {renderIcon()}
        <Text size='small' className={colorClassName}>{diff}</Text>
    </div>
}

export default Trend
